import 'flatpickr/dist/themes/airbnb.css'
import {Field} from 'formik'
import {useIntl} from 'react-intl'
import InputMask from 'react-input-mask'
import Select, {components} from 'react-select'
import {useEffect, useState} from 'react'
import {termsConditions} from '../assets/termsConditions'
import getCategories from '../services/getCategories'
import getPartnerTypeList from '../services/getPartnerType'
import getCities from '../services/getCities'
import getSubCategories from '../services/getSubCategories'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import PhoneNumberInput from 'src/app/modules/phoneNumberInput'
import ControlledInput from 'src/feature/bite/component/ControlledInput'

export default function FormStarted({
  errors,
  touched,
  setTouched,
  values,
  setFieldValue,
  isLoading,
}: {
  errors: any
  touched: any
  values: any
  setFieldValue: any
  list?: {countries: any[]; cities: any[]; regions: any[]}
  changeCountry?: (countryId: string) => void
  changeCity?: (cityId: string) => void
  isLoading?: boolean
  setIsLoading?: (value: boolean) => void
  setTouched?: any
  handleSubmit?: any
}) {
  const [categoryList, setCategoryList] = useState<any[]>([])
  const [partnerTypeList, setPartnerTypeList] = useState<any[]>([])
  const [cityList, setCityList] = useState<any[]>([])
  const [subCategoryList, setSubCategoryList] = useState<any[]>([])

  const intl = useIntl()

  useEffect(() => {
    getCategories().then((category: any) => {
      setCategoryList(category || [])
    })

    getPartnerTypeList().then((partnerType: any) => {
      setPartnerTypeList(partnerType || [])
    })

    getCities('f109e594-b301-ec11-a85d-000d3a229408').then((city: any) => {
      setCityList(city || [])
    })
  }, [])

  useEffect(() => {
    if (values.categoryIDs) {
      getSubCategories({merchantCategoryID: values.categoryIDs}).then((subCategory: any) => {
        setSubCategoryList(subCategory || [])

        const selectedCategories = values.categoryIDs

        values.subCategoryIDs.forEach((subCategoryID: string) => {
          const subCategory = subCategoryList.find((item) => item.id === subCategoryID)
          const isSubCategoryInList = selectedCategories.includes(subCategory?.merchantCategoryID)
          if (!isSubCategoryInList) {
            setFieldValue(
              'subCategoryIDs',
              values.subCategoryIDs.filter((id: string) => id !== subCategoryID)
            )
          }
        })
      })
    }
  }, [setFieldValue, values.categoryIDs])

  return (
    <div
      className='d-flex flex-column flex-root px-10 d-flex gap-10 justify-content-center align-items-center'
      id='kt_app_root'
    >
      <div className='d-flex flex-column justify-content-center gap-10 w-75'>
        <div className='card w-100'>
          <div className='d-flex flex-column w-100'>
            <div
              className='card-body d-flex justify-content-between'
              style={{
                gap: '12rem',
              }}
            >
              <div className='w-50'>
                <h3 className='text-black '>
                  {/* Corporate Information */}
                  Personal Information
                  <OverlayTrigger
                    placement='right'
                    overlay={
                      <Tooltip>
                        Provide your basic details to set up your freelancer profile. If you are
                        operating in multiple categories, ensure that you have added all relevant
                        categories and their corresponding subcategories. This will help accurately
                        classify your services and products, making them more accessible to
                        customers.
                      </Tooltip>
                    }
                  >
                    <i className='bi bi-info-circle text-primary ms-1'></i>
                  </OverlayTrigger>
                </h3>
                <div className='row my-5'>
                  <div className='col-md-6'>
                    <label className='form-label required'>
                      {/* Name */}
                      {intl.formatMessage({id: 'NAME'})}
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip>
                            Enter your first name as it should appear on your profile.
                          </Tooltip>
                        }
                      >
                        <i className='bi bi-info-circle text-primary ms-1'></i>
                      </OverlayTrigger>
                    </label>
                    <ControlledInput
                      type='text'
                      name='name'
                      id='name'
                      className='form-control'
                      placeholder={intl.formatMessage({id: 'NAME'})}
                      maxLength={51}
                      setFieldValue={setFieldValue}
                    />
                    {errors.name && touched.name && (
                      <div className='text-danger'>{errors.name}</div>
                    )}
                  </div>
                  <div className='col-md-6'>
                    <label className='form-label required'>
                      {/* Surname */}
                      {intl.formatMessage({id: 'LAST_NAME'})}
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip>Enter your last name to ensure proper identification.</Tooltip>
                        }
                      >
                        <i className='bi bi-info-circle text-primary ms-1'></i>
                      </OverlayTrigger>
                    </label>
                    <ControlledInput
                      type='text'
                      name='lastName'
                      id='lastName'
                      className='form-control'
                      placeholder={intl.formatMessage({id: 'LAST_NAME'})}
                      maxLength={51}
                      setFieldValue={setFieldValue}
                    />
                    {errors.lastName && touched.lastName && (
                      <div className='text-danger'>{errors.lastName}</div>
                    )}
                  </div>
                </div>

                <div className='row my-5'>
                  <div className='col-md-6'>
                    <label className='form-label fw-bold required'>
                      {intl.formatMessage({id: 'PROVIDER.SELECT_TYPE'})}
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip>
                            Select your role or professional classification from the available
                            options.
                          </Tooltip>
                        }
                      >
                        <i className='bi bi-info-circle text-primary ms-1'></i>
                      </OverlayTrigger>
                    </label>
                    <Select
                      id='partnerTypeID'
                      name='partnerTypeID'
                      options={partnerTypeList.map((item) => ({value: item.id, label: item.name}))}
                      className='custom-select'
                      onChange={(e: any) => {
                        setFieldValue('partnerTypeID', e.value)
                      }}
                      value={partnerTypeList
                        ?.filter((item) => item.id === values.partnerTypeID)
                        .map((item) => ({value: item.id, label: item.name}))}
                    />
                    {errors.partnerTypeID && touched.partnerTypeID && (
                      <div className='text-danger'>{errors.partnerTypeID}</div>
                    )}
                  </div>

                  <div className='col-md-6'>
                    <label className='form-label fw-bold required'>
                      {intl.formatMessage({id: 'TITLE.CATEGORY'})}
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip>
                            Choose the main service category that best represents your expertise.
                          </Tooltip>
                        }
                      >
                        <i className='bi bi-info-circle text-primary ms-1'></i>
                      </OverlayTrigger>
                    </label>

                    <Select
                      id='categoryIDs'
                      name='categoryIDs'
                      isMulti
                      options={
                        categoryList &&
                        categoryList?.map((item) => ({value: item.id, label: item.name}))
                      }
                      className='custom-select'
                      onChange={(e: any) => {
                        setFieldValue(
                          'categoryIDs',
                          e.map((item: any) => item.value)
                        )
                      }}
                      value={categoryList
                        ?.filter((item) => values.categoryIDs?.includes(item.id))
                        ?.map((item) => ({value: item.id, label: item.name}))}
                    />
                    {errors.categoryIDs && touched.categoryIDs && (
                      <div className='text-danger'>{errors.categoryIDs}</div>
                    )}
                  </div>

                  <div className='row mt-5'>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-label required'>
                          {/* Brand Name */}
                          {intl.formatMessage({id: 'TITLE.SUBCATEGORY'})}
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip>
                                Choose a more specific sub-category that defines your services
                                within the selected category.
                              </Tooltip>
                            }
                          >
                            <i className='bi bi-info-circle text-primary ms-1'></i>
                          </OverlayTrigger>
                        </label>
                        <Select
                          id='subCategoryIDs'
                          name='subCategoryIDs'
                          isMulti
                          components={{
                            GroupHeading: ({children, ...props}) => (
                              // @ts-ignore
                              <components.GroupHeading {...props}>
                                <span className='fw-bold text-primary border-bottom pb-2 fs-7'>
                                  {children}
                                </span>
                              </components.GroupHeading>
                            ),
                            Option: ({children, ...props}) => (
                              // @ts-ignore
                              <components.Option {...props}>
                                <span className='pl-10 ms-3'>{children}</span>
                              </components.Option>
                            ),
                          }}
                          options={
                            subCategoryList &&
                            subCategoryList.reduce((acc: any[], item) => {
                              const group = acc.find((g) => g.label === item.merchantCategoryName)
                              if (group) {
                                group.options.push({
                                  value: item.id,
                                  label: item.name,
                                })
                              } else {
                                acc.push({
                                  label: item.merchantCategoryName,
                                  options: [{value: item.id, label: item.name}],
                                })
                              }
                              return acc
                            }, [])
                          }
                          className='custom-select'
                          onChange={(e: any) => {
                            setFieldValue(
                              'subCategoryIDs',
                              e.map((item: any) => item.value)
                            )
                          }}
                          value={subCategoryList
                            ?.filter((item) => values.subCategoryIDs?.includes(item.id))
                            ?.map((item) => ({value: item.id, label: item.name}))}
                        />
                        {errors.subCategoryIDs && touched.subCategoryIDs && (
                          <div className='text-danger'>{errors.subCategoryIDs}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='w-50'>
                <h3 className='text-black '>
                  Address Details
                  <OverlayTrigger
                    placement='right'
                    overlay={
                      <Tooltip>
                        Specify your location to ensure accurate service availability and
                        communication.
                      </Tooltip>
                    }
                  >
                    <i className='bi bi-info-circle text-primary ms-1'></i>
                  </OverlayTrigger>
                </h3>
                <div className='row  my-5'>
                  <div className='col-md-12'>
                    <label className='form-label required'>
                      Address
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip>Provide your full address.</Tooltip>}
                      >
                        <i className='bi bi-info-circle text-primary ms-1'></i>
                      </OverlayTrigger>
                    </label>
                    <Field
                      type='text'
                      name='address'
                      id='address'
                      className='form-control'
                      placeholder='Address'
                      maxLength={51}
                    />
                    {errors.address && touched.address && (
                      <div className='text-danger'>{errors.address}</div>
                    )}
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-6'>
                    <label className='form-label required'>
                      Apt/Building No
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip>
                            Enter your apartment or building number to complete the address.
                          </Tooltip>
                        }
                      >
                        <i className='bi bi-info-circle text-primary ms-1'></i>
                      </OverlayTrigger>
                    </label>
                    <Field
                      type='text'
                      name='aptBuildingNo'
                      id='aptBuildingNo'
                      className='form-control'
                      // placeholder='Surname'
                      placeholder='Apt/Building No'
                      maxLength={51}
                    />
                    {errors.aptBuildingNo && touched.aptBuildingNo && (
                      <div className='text-danger'>{errors.aptBuildingNo}</div>
                    )}
                  </div>

                  <div className='col-md-6'>
                    <label className='form-label required'>
                      {/* Surname */}
                      {intl.formatMessage({id: 'GLOBAL.CITY'})}
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip>
                            Select the city where you are based or primarily operate.
                          </Tooltip>
                        }
                      >
                        <i className='bi bi-info-circle text-primary ms-1'></i>
                      </OverlayTrigger>
                    </label>

                    <Select
                      id='cityID'
                      name='cityID'
                      className='custom-select'
                      placeholder={intl.formatMessage({
                        id: 'GLOBAL.CITY',
                      })}
                      options={cityList?.map((item) => ({value: item.id, label: item.name}))}
                      value={cityList
                        ?.filter((item) => item.id === values.cityID)
                        ?.map((item) => ({value: item.id, label: item.name}))}
                      onChange={(e: any) => {
                        setFieldValue('cityID', e.value)
                      }}
                    />
                    {errors.cityID && touched.cityID && (
                      <div className='text-danger'>{errors.cityID}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card w-100'>
          <div className='card-body d-flex flex-column gap-5'>
            <h3 className='text-black '>
              Communication Details
              <OverlayTrigger
                placement='right'
                overlay={
                  <Tooltip>
                    Enter your contact information to receive updates and manage customer
                    interactions
                  </Tooltip>
                }
              >
                <i className='bi bi-info-circle text-primary ms-1'></i>
              </OverlayTrigger>
            </h3>

            <div className='row'>
              <div className='col-md-4'>
                <label className='form-label required'>
                  {/* Email */}
                  {intl.formatMessage({id: 'EMAIL'})}
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip>
                        Provide a valid email address for notifications and communication.
                      </Tooltip>
                    }
                  >
                    <i className='bi bi-info-circle text-primary ms-1'></i>
                  </OverlayTrigger>
                </label>
                <Field
                  type='email'
                  name='email'
                  id='email'
                  className='form-control'
                  placeholder={intl.formatMessage({id: 'EMAIL'})}
                  maxLength={101}
                />
                {errors.email && touched.email && <div className='text-danger'>{errors.email}</div>}
              </div>
              <div className='col-md-4'>
                <div className='form-group'>
                  <label className='form-label required'>
                    {intl.formatMessage({id: 'PHONE'})}
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip>
                          Enter a phone number where customers or the platform can reach you.
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </label>
                  {/* <PatternFormat
                      name='phone'
                      className='form-control'
                      format='+971 (###) #### ###'
                      allowEmptyFormatting
                      mask='_'
                      value={values.phone || ''}
                      onValueChange={(values) => {
                        setFieldValue('phone', values.value)
                      }}
                    /> */}
                  {/* <InputMask
                    mask={'+\\9\\7\\1\\ 99 999 9999'}
                    className='form-control'
                    value={values.phone || ''}
                    onChange={(e) => {
                      console.log(e.target.value)
                      setFieldValue('phone', e.target.value)
                    }}
                    onClick={() => {
                      setTouched({...touched, phone: true})
                    }}
                    onBlur={() => {
                      setTouched({...touched, phone: true})
                    }}
                  /> */}
                  <PhoneNumberInput
                    values={values}
                    setFieldValue={setFieldValue}
                    setTouched={setTouched}
                  />
                  {errors.phone && touched.phone && (
                    <div className='text-danger'>{errors.phone}</div>
                  )}
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-md-4'>
                <div className='form-group'>
                  <label className='form-label'>
                    {/* Brand Name */}
                    {intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.WEB_SITE'})}
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip>
                          If applicable, enter your professional website or portfolio link.
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </label>
                  <Field
                    type='text'
                    value={values.webSite}
                    onChange={(e) => {
                      setFieldValue('webSite', e.target.value)
                    }}
                    className='form-control'
                    placeholder={intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.WEB_SITE'})}
                  />
                  {errors.webSite && touched.webSite && (
                    <div className='text-danger'>{errors.webSite}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card w-100'>
          <div className='card-body pb-0'>
            <div className='w-100 d-flex flex-column gap-3'>
              <div className='form-info-box'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: termsConditions,
                  }}
                ></div>
              </div>

              <div className='d-flex align-items-center mt-5'>
                <Field type='checkbox' className='form-check-input' id='check' name='check' />
                <label className='form-label ms-3 fw-bold text-primary fs-3' htmlFor='check'>
                  {/* I agree to the terms and conditions */}
                  {intl.formatMessage({id: 'I_AGREE_TO_THE_TERMS_AND_CONDITIONS'})}
                </label>
              </div>
              <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                {errors.check && touched.check && (
                  <div className='fv-help-block'>{errors.check}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='w-100 d-flex justify-content-center'>
        {isLoading ? (
          <button
            type='submit'
            className='btn btn-dark d-flex align-items-center px-20 py-5'
            disabled
          >
            {/* Continue */}
            {intl.formatMessage({id: 'NEXT'})}
          </button>
        ) : (
          <div className='pb-10'>
            <div className='d-flex justify-content-center'>
              <button className='btn btn-dark w-100 py-5 px-20' type='submit'>
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
